import React from "react";
import { TableComponents } from "react-virtuoso";
import {
  Table,
  Paper,
  TableRow,
  TableBody,
  TableHead,
  TableContainer,
} from "@mui/material";

import { ITableItem } from "./types";

export const Components: TableComponents<ITableItem[]> = {
  Scroller: React.forwardRef((props, ref) => (
    <TableContainer component={Paper} {...props} ref={ref} />
  )),
  Table: (props) => (
    <Table
      {...props}
      sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
    />
  ),
  TableHead: React.forwardRef<HTMLTableSectionElement>((props, ref) => (
    <TableHead {...props} ref={ref} />
  )),
  TableRow: (props) => <TableRow hover {...props} />,
  TableBody: React.forwardRef<HTMLTableSectionElement>((props, ref) => (
    <TableBody {...props} ref={ref} />
  )),
};
